var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistorySidebarShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 156,
    viewBox: "0 0 7 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1252",
    "data-name": "\\uADF8\\uB8F9 1252",
    transform: "translate(-183 -2137.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_30",
    "data-name": "\\uC120 30",
    y2: 148,
    transform: "translate(186.5 2144.5)",
    fill: "none",
    stroke: "rgba(255,255,255,0.5)",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeDasharray: "0 5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_580",
    "data-name": "\\uD0C0\\uC6D0 580",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(183 2137.5)",
    fill: "#868686"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistorySidebarShort);
export default __webpack_public_path__ + "static/media/history_sidebar_short.c20bfa5b059b0ba81e5f52e816616e5b.svg";
export { ForwardRef as ReactComponent };